angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListViewZmController',
	function(
		CONFIG,
		$rootScope, $scope, $stateParams, $timeout,
		UserListService, InvitationCreateService, InvitationListService, InvitationDeleteService,
		ApprovationListListService, ApprovationListEditService, Session,
		$confirm
	) {

	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.event_id           = $stateParams.event_id;

	$rootScope.getInvitationList( $stateParams.invitation_list_id );

	$scope.invitations = [];
	$scope.usersToExclude = [];

	$scope.seats = 0;

	$scope.utentiDefault = "Nessun utente";

	$rootScope.getApprovationList($stateParams.id);

	$scope.$on( 'approvation_list_loaded', function() {
		updateSeatsNumber();
	});

	$scope.totalInvitations = 0;
	$scope.totalSent        = 0;
	$scope.totalConfirmed   = 0;
	$scope.totalWaiting     = 0;
	$scope.totalRefused     = 0;
	$scope.totalCheckedIn   = 0;

	var userPushInterval, countInterval = 0;

	$scope.loadInvitations = function() {
		$scope.showLoader();

		InvitationListService
			.fullList( $rootScope.invitationListData.id, $stateParams.id )
			.then(function(data) {

				if (!data.error) {

					var totalInvitations = 0,
						totalSent        = 0,
						totalConfirmed   = 0,
						totalWaiting     = 0,
						totalRefused     = 0,
						totalCheckedIn   = 0;

					angular.forEach(data, function(invitation, key) {
						if ( invitation.user ) {
							$scope.usersToExclude.push(invitation.user.id);

							switch ( invitation.status ) {
								case 'waiting':
									totalWaiting += 1;
									break;
								case 'confirmed':
									totalConfirmed += 1;
									break;
								case 'canceled':
									totalRefused += 1;
									break;
							}

							if ( invitation.checked_in ) {
								totalCheckedIn += 1;
							}

							if ( invitation.sent_date ) {
								totalSent += 1;
							}

							totalInvitations += 1;
						}
					});

					$scope.invitations = $scope.invitations.concat( data );

					$scope.totalInvitations = totalInvitations;
					$scope.totalSent        = totalSent;
					$scope.totalConfirmed   = totalConfirmed;
					$scope.totalWaiting     = totalWaiting;
					$scope.totalRefused     = totalRefused;
					$scope.totalCheckedIn   = totalCheckedIn;

					$scope.loadUsers();
					updateSeatsNumber();

					$scope.hideLoader();
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.userList = [];
	$scope.loadUsers = function() {
		$scope.showLoader();

		var id = ( Session.role !== 'zone_manager' ? $rootScope.approvationListData.user_id : Session.id );

		UserListService
			.listSubnet(id, $scope.usersToExclude, $scope.invitation_list_id)
			.then(function(data) {

				$scope.hideLoader();

				if (!data.error) {

					$scope.utentiDefault = "Attendere...Caricamento in corso...";

					// setTimeout(function(){
					//  	$scope.userList = data;
					// }, 200 );

					var i,j = 0, userListChunk = [],chunk = 40;

					for (i=0,j=data.length; i<j; i+=chunk) {
						userListChunk[i/chunk] = data.slice( i, i + chunk );
					}

					$scope.showLoader();
					userPushInterval = setInterval( chunkHandler, 50, userListChunk );

				} else {
					$rootScope.manageError(data);
				}
			});
	};

	function chunkHandler( arrayData ) {
		if ( countInterval >= arrayData.length ) {
			clearInterval( userPushInterval );
			$scope.hideLoader();
		}

		$scope.userList.push.apply( $scope.userList, arrayData[countInterval] );
		$scope.$apply();

		countInterval++;
	}

	$scope.$on( 'invitation_list_loaded', function() {
		$scope.loadInvitations();
	});


	function updateSeatsNumber() {
		$scope.seats = $rootScope.approvationListData.seats - $scope.invitations.length;
	}

	$scope.inviteUser = function(userId) {
		$scope.inviteSelectedUser( [ userId ] );
	};

	$scope.getTotalUserSelected = function() {
		var counter = 0;
		angular.forEach($scope.userList, function(user, key) {
			if ( user.checked ) {
				counter++;
			}
		});
		return counter;
	};

	$scope.inviteSelectedUser = function(userIds) {
		if ( !userIds ) {
			userIds = [];
			angular.forEach($scope.userList, function(user, key) {
				if ( user.checked ) {
					userIds.push(user.id);
				}
			});
		}

		$scope.showLoader();
		InvitationCreateService
			.inviteUser({
				event: $rootScope.eventData.id,
				invitation_list: $rootScope.invitationListData.id,
				approvation_list: $rootScope.approvationListData.id,
				users: userIds
			})
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					angular.forEach(data, function(invitation) {
						$scope.usersToExclude.push(invitation.user_id);
						$scope.invitations.push(invitation);
						updateSeatsNumber();

						angular.forEach($scope.userList, function(u, index) {
							if ( u.id == invitation.user_id ) {
								$scope.userList.splice(index, 1);
							}
						});
					});

					$scope.showSuccessMsg('Invito inviato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.deleteInvitation = function(invitationId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'invito?',
			text: 'Confermi la cancellazione dell\'invito?'
		}).then(function() {

			$scope.showLoader();
			InvitationDeleteService.delete({ id: invitationId })
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.invitations, function(invitation, key) {
							if ( invitation.id == invitationId ) {
								angular.forEach($scope.usersToExclude, function(userToExclude, index) {
									if ( userToExclude == invitation.user.id ) {
										$scope.usersToExclude.splice(index, 1);
									}
								});
								$scope.invitations.splice(key, 1);
							}
						});

						// Reload the users and update the seats number
						$scope.loadUsers();
						updateSeatsNumber();

						$scope.showSuccessMsg('Invito eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

	$scope.toggleUser = function(userId) {
		if ( $scope.getTotalUserSelected() < $scope.seats ) {
			angular.forEach($scope.userList, function(user, key) {
				if ( user.id == userId ) {
					user.checked = !user.checked;
					$scope.userList[key] = user;
				}
			});
		}
	};

	$scope.confirmList = function() {
		$confirm({
			title: 'Sei sicuro di voler confermare la lista?',
			text: 'Confermi la lista per l\'approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.updateStatus( $rootScope.approvationListData.id, 'confirmed')
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$rootScope.approvationListData = data;
						$scope.showSuccessMsg('Lista inviata per visione all\'Area Manager!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});
	};

	$scope.save = function() {
		$scope.showLoader();
		$timeout(function() {
			$scope.hideLoader();
			$scope.showSuccessMsg('Lista salvata', '');
		}, 1000);
	};


	$scope.downloadExportSubnet = false;
	$scope.exportSubnetUrl      = '';

	$scope.prepareExportSubnetUrl = function() {
		$scope.showLoader();
		UserListService
			.exportSubnet( ( Session.role !== 'zone_manager' ? $rootScope.approvationListData.user_id : Session.id ) )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportSubnet = true;
					$scope.exportSubnetUrl = url;
				}
			});
	};


	$scope.downloadExportSelected = false;
	$scope.exportSelectedUrl      = '';

	$scope.prepareExportSelectedUrl = function() {
		$scope.showLoader();
		ApprovationListListService
			.exportList( $stateParams.id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportSelected = true;
					$scope.exportSelectedUrl      = url;
				}
			});
	};

});